export type DataScreen =
  | { screen: 'sets'; shared: boolean }
  | { screen: 'new-set' }
  | { screen: 'records'; setId: string }
  | { screen: 'settings'; setId: string }
  | { screen: 'access'; setId: string; recordId?: string }
  | { screen: 'new-record'; setId: string }
  | { screen: 'record'; setId: string; recordId: string }
  | { screen: 'not-found' };

const ID = /^[0-9a-f]{24}$/;

// /data, /data/shared, /data/new, /data/<setId>, /data/<setId>/settings, /data/<setId>/access, /data/<setId>/new, /data/<setId>/<recordId>, /data/<setId>/<recordId>/access
export function parseDataPath(path: string): DataScreen {
  const [root, setId, sub, ...rest] = path.split('/').filter(Boolean);
  if (root !== 'data') return { screen: 'not-found' };
  if (rest.length > 0) {
    const recordAccess = rest.length === 1 && rest[0] === 'access' && setId && sub && ID.test(setId) && ID.test(sub);
    return recordAccess ? { screen: 'access', setId, recordId: sub } : { screen: 'not-found' };
  }
  if (!setId) return { screen: 'sets', shared: false };
  if (setId === 'shared') return sub ? { screen: 'not-found' } : { screen: 'sets', shared: true };
  if (setId === 'new') return sub ? { screen: 'not-found' } : { screen: 'new-set' };
  if (!ID.test(setId)) return { screen: 'not-found' };
  if (!sub) return { screen: 'records', setId };
  if (sub === 'settings') return { screen: 'settings', setId };
  if (sub === 'access') return { screen: 'access', setId };
  if (sub === 'new') return { screen: 'new-record', setId };
  return ID.test(sub) ? { screen: 'record', setId, recordId: sub } : { screen: 'not-found' };
}

// Data Studio's screens are for holders of its permissions; what another company shares (the shared list, a set's records)
// opens for anyone it's shared with, feature or not (#12 D16, D34). The server still decides what each reads.
export function dataScreenOpen(screen: DataScreen, holdsDataStudio: boolean): boolean {
  if (holdsDataStudio) return true;
  if (screen.screen === 'sets') return screen.shared;
  return screen.screen === 'records' || screen.screen === 'record' || screen.screen === 'new-record';
}
